import { Upload, type UploadOptions, type PreviousUpload } from "tus-js-client";
import type { OperationalUploadSession } from "@rekonas/domain";
import { apiBaseUrl } from "@rekonas/data-access";

export interface TusUploadCallbacks {
  onError: (error: Error) => void;
  onProgress: (uploaded: number, total: number) => void;
  onSuccess: () => void;
}

interface TusOptionsInput extends TusUploadCallbacks {
  session: OperationalUploadSession;
  token: string;
  file: File;
}

function transportUrl(path: string): string {
  return new URL(path, `${apiBaseUrl}/`).toString();
}

export function buildTusUploadOptions(input: TusOptionsInput): UploadOptions {
  return {
    endpoint: transportUrl(input.session.tus.endpoint),
    uploadUrl: input.session.tus.upload_url ? transportUrl(input.session.tus.upload_url) : null,
    uploadSize: input.session.tus.size_bytes,
    headers: { Authorization: `Bearer ${input.token}` },
    metadata: { ...input.session.tus.metadata },
    retryDelays: [0, 1_000, 3_000, 5_000, 10_000],
    chunkSize: 8 * 1024 * 1024,
    storeFingerprintForResuming: true,
    removeFingerprintOnSuccess: true,
    onError: input.onError,
    onProgress: input.onProgress,
    onSuccess: input.onSuccess,
  };
}

export function createTusUpload(input: TusOptionsInput): Upload {
  return new Upload(input.file, buildTusUploadOptions(input));
}

export function findMatchingPreviousUpload(
  previous: PreviousUpload[],
  uploadRef: string,
): PreviousUpload | undefined {
  return previous.find((entry) => entry.metadata?.upload_ref === uploadRef);
}
